const WORDS_PER_MINUTE = 200;
const SECONDS_PER_IMAGE = 10;
const SECONDS_PER_CODE_BLOCK = 15;

function extractStructuredText(contentArray = []) {
  let fullText = "";
  let imageCount = 0;
  let codeBlocks = 0;

  if (!Array.isArray(contentArray)) {
    return { text: "", imageCount: 0, codeBlocks: 0 };
  }

  contentArray.forEach((block) => {
    if (block.img) {
      imageCount += Array.isArray(block.img.src) ? block.img.src.length : 1;
      fullText += `${block.img.alt || ""} ${block.img.caption || ""} `;
    } else if (block.p) {
      fullText += `${block.p} `;
    } else if (block.h3) {
      fullText += `${block.h3} `;
    } else if (block.code?.content) {
      codeBlocks += 1;
      fullText += `${block.code.content} `;
    }
  });

  return {
    text: fullText.trim(),
    imageCount,
    codeBlocks,
  };
}

function getReadingTime(contentArray, label = "min read") {
  const { text, imageCount, codeBlocks } = extractStructuredText(contentArray);
  const words = text.split(/\s+/).filter(Boolean).length;
  const seconds =
    (words / WORDS_PER_MINUTE) * 60 +
    imageCount * SECONDS_PER_IMAGE +
    codeBlocks * SECONDS_PER_CODE_BLOCK;

  return `${Math.max(1, Math.ceil(seconds / 60))} ${label}`;
}

const read = {
  extractStructuredText,
  getReadingTime,
};

export default read;
